module.exports = __webpack_public_path__ + "img/c.5d4dd827.jpg";